/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuctionCatalogPartMaterialPriceDto } from '../../models/auction-catalog-part-material-price-dto';

export interface GetAuctionCatalogPartMaterialPrices$Params {
  partId: number;
  'X-API-Version'?: string;
}

export function getAuctionCatalogPartMaterialPrices(http: HttpClient, rootUrl: string, params: GetAuctionCatalogPartMaterialPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AuctionCatalogPartMaterialPriceDto>>> {
  const rb = new RequestBuilder(rootUrl, getAuctionCatalogPartMaterialPrices.PATH, 'get');
  if (params) {
    rb.path('partId', params.partId, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AuctionCatalogPartMaterialPriceDto>>;
    })
  );
}

getAuctionCatalogPartMaterialPrices.PATH = '/api/auction-catalogs/parts/{partId}/material-prices';
